module.exports = __webpack_public_path__ + "img/img-nz@2x.2e6b5524.png";